import FormContainer from 'components/Forms/FormContainer';
import { TextField } from 'components/TextField';
import { FormikProps } from 'formik';

import { FieldLabel, ICostCenterFormProps } from './types';
import { CostCenterFormValues, CostCenterValidationSchema } from './validation';

export default function CostCenterForm({
  onSubmit,
  initialValues,
  buttons,
  detailFormRef
}: ICostCenterFormProps & {
  detailFormRef: React.RefObject<FormikProps<CostCenterFormValues>>;
}) {
  return (
    <FormContainer
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={CostCenterValidationSchema}
      buttons={buttons}
      formRef={detailFormRef}
    >
      {({
        values,
        handleChange,
        errors,
        touched
      }: FormikProps<CostCenterFormValues>) => (
        <>
          <TextField
            id="name"
            name="name"
            margin="normal"
            label={FieldLabel.Name}
            value={values.name}
            onChange={handleChange}
            error={touched.name && errors.name ? true : false}
            helperText={touched.name && errors.name}
          />
        </>
      )}
    </FormContainer>
  );
}
